const MAX_CANVAS_AREA = 16777216 // 4096x4096 safe limit
const MAX_DEVICE_PIXEL_RATIO = 2 // Prevent excessive memory usage

export function getCanvasOptimalScale(width: number, height: number): number {
  const area = width * height
  if (area <= MAX_CANVAS_AREA) return 1
  return Math.sqrt(MAX_CANVAS_AREA / area) * 0.95 // 5% safety margin
}

export function getCanvasOptimalDevicePixelRatio(): number {
  return Math.min(MAX_DEVICE_PIXEL_RATIO, window.devicePixelRatio || 1)
}
